module.exports = __webpack_public_path__ + "media/images/logos/University-of-Southampton-171367016161bd421375075d2ee74e9f.svg";